import { Component } from "@angular/core";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import LocalizationConstants from "src/app/constants/localization-constants";
import { AuthService } from "src/app/services/auth.service";
import { BrandingService } from "src/app/services/branding.service";
import { CompanyService } from "src/app/services/company.service";
import { getSalesforceMigrationContactEmail } from "src/app/utils/company.utils";

@Component({
  selector: "salesforce-migration-notice",
  templateUrl: "./salesforce-migration-notice.component.html",
  styleUrls: ["./salesforce-migration-notice.component.scss"],
  standalone: false,
})
export class SalesforceMigrationNoticeComponent {
  readonly localizationConstants = LocalizationConstants;

  faCircleInfo = faCircleInfo;

  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private brandingService: BrandingService,
  ) {}

  public get appName(): string {
    return this.brandingService.getProductName();
  }

  /** Contact email as HTML, so it is rendered as a mailto link inside the translated text. */
  public get emailLink(): string {
    const email = getSalesforceMigrationContactEmail(
      this.authService.user,
      this.companyService.selectedCompany,
    );

    return `<a href="mailto:${email}">${email}</a>`;
  }
}
